import React, { useState, forwardRef, useRef, useCallback } from 'react';
import { Select, SelectOption } from 'appkit-react';
// import { useSelector } from 'react-redux';
import { iconList } from './icon.config';
import './iconSelector.scss';
import { ModuleIcon } from '@components';
import { findParentNode } from '@utils/common';

const IconSelector = forwardRef(
  ({ value, onChange = () => {}, toggleZIndex, ...props }, ref) => {
    const [icon, setIcon] = useState(null);

    const onIconChange = (newIcon) => {
      setIcon(newIcon);
      onChange(newIcon);
    };

    const cellObj = props.formInstance?.getFieldValue?.([
      props.rowName,
      props.rowIndex,
    ]);
    const { type } = cellObj || {};
    const wrapperRef = useRef(null);
    const onClick = useCallback(() => {
      if (wrapperRef.current && toggleZIndex) {
        const cellNode = findParentNode(wrapperRef.current, 'cell');
        if (cellNode && cellNode.style.zIndex === '1') {
          cellNode.style.zIndex = '2';
        }
      }
    }, [toggleZIndex]);
    const onClose = useCallback(() => {
      if (wrapperRef.current && toggleZIndex) {
        const cellNode = findParentNode(wrapperRef.current, 'cell');
        if (cellNode && cellNode.style.zIndex !== '1') {
          cellNode.style.zIndex = '1';
        }
      }
    }, [toggleZIndex]);

    return (
      <div className="icon-selector" ref={wrapperRef}>
        <Select
          value={icon || value}
          onSelect={onIconChange}
          size="large"
          {...props}
          placeholder="Pick"
          onClick={onClick}
          onClose={onClose}
        >
          {type === 'default' ? (
            <SelectOption value={value}>
              <ModuleIcon type={value} />
            </SelectOption>
          ) : (
            iconList.map((type, i) => (
              <SelectOption value={type} key={i}>
                <ModuleIcon type={type} isActive />
              </SelectOption>
            ))
          )}
        </Select>
      </div>
    );
  },
);

export default IconSelector;
